import { API_URLS, } from "@constants";
import { dehydrate, hydrate, } from "@hydra";
import type { IBracketStore, } from "@store";
import { awaitTruthy, loadAtTimeout, } from "@store/helpers";
import { fetchApiResponseHandler } from "@utils";
import { produce, } from 'immer';
import type { StateCreator, } from "zustand";
import type { IWalletPointsSlice, WalletPointsGetResult } from "./types";

export const createWalletPointsSlice: StateCreator<IBracketStore, [], [], IWalletPointsSlice> = ( set, get ) => {


	const fetch = async ( force = false, ) => {
		const AAA = get();
		const { ready, fetching, } = get().bars.walletPoints;
		if(!force && (ready || fetching)) {
			return;
		}


		set(produce(state => {
			state.bars.walletPoints.ready = false;
			state.bars.walletPoints.fetching = true;
			state.bars.walletPoints.isLoading = true;
			state.bars.walletPoints.isError = false;
			state.bars.walletPoints.error = null;
		}));

		try {

			const { useStore, } = await import("@store/useStore");
			await awaitTruthy(useStore, state => state.wallet.ready);

			const { fetched, props, } = await hydrate("wallet_points");

			if(fetched) {
				set(produce(state => {
					Object.entries(props).forEach(([key, value]) => {
						// @ts-ignore -- fix later
						if(typeof key === "string" && key in state.bars.walletPoints) {
							state.bars.walletPoints[key] = value;
							state.bars.walletPoints.isLoading = false;
						}
					});
				}));
			}

			if(fetched){
				set(produce(state => {
					state.bars.walletPoints.ready = true;
					state.bars.walletPoints.fetching = false;
					state.bars.walletPoints.isLoading = false;
				}))
				return;
			}

			const data = await fetchApiResponseHandler<WalletPointsGetResult>({
				url: `${API_URLS.BARS}/wallet/points?address=${get().wallet.address}`,
				signal: new AbortController().signal,
				onAbort: () => console.log("wallet points request aborted"),
			});

			set(produce(state => {
				state.bars.walletPoints.ready = true;
				state.bars.walletPoints.fetching = false;
				state.bars.walletPoints.data = data;
				state.bars.walletPoints.isLoading = false;
			}));

			dehydrate("wallet_points", { data, });


		}
		catch (error) {
		
			set(produce(state => {
				state.bars.walletPoints.isLoading = false;
				state.bars.walletPoints.isError = true;
				state.bars.walletPoints.error =
					error instanceof Error
						? error
						: new Error("An unknown error occurred");
			}));

		}

	};

	const update = (updater: (oldData: WalletPointsGetResult | null) => WalletPointsGetResult) => {
		set(produce(state => {
			state.bars.walletPoints.data = updater(state.bars.walletPoints.data);
		}));
	};

	const setData = (data: WalletPointsGetResult) => {
		set(produce(state => {
			state.bars.walletPoints.data = data;
		}));
	};

	const setError = (error: Error) => {
		set(produce(state => {
			state.bars.walletPoints.isError = true;
			state.bars.walletPoints.error = error;
		}));
	};

	const reset = () => {
		console.warn("createWalletPointsSlice::reset not implemented");
	};

	const resetAsync = async () => {
		console.warn("createWalletPointsSlice::resetAsync not implemented");
	};

	( async () => setTimeout(async () => await fetch(), 100) )();
	// place at the bottom of the call stack.
	// loadAtTimeout("bars.walletPoints", 2000);

	return {
		ready: false,
		fetching: false,
		data: null,
		isLoading: false,
		isError: false,
		error: null,
		fetch,
		reset,
		resetAsync,
		update,
		setData,
		setError,
	};

};
